import { useEffect } from 'react';
import { useMatch, useNavigate } from 'react-router-dom';

import { featureFlagsSelectors } from 'app-components/flux/feature-flags';

import { useAppSelector } from 'hooks/redux';
import { connectedAiPath } from 'containers/App/paths';
import { consumeConnectedAiLanding } from 'utils/mcp/pendingAuthorize';

export const useConnectedAiLanding = (): void => {
  const navigate = useNavigate();
  const isGetStartedRoute = useMatch('/get-started') !== null;
  const isConnectedAiEnabled = useAppSelector((state) =>
    Boolean(featureFlagsSelectors.getFeatureFlag(state, 'mcpConnectedAiRelease')),
  );

  useEffect(() => {
    if (!isConnectedAiEnabled || isGetStartedRoute) {
      return;
    }
    const clientId = consumeConnectedAiLanding();
    if (!clientId) {
      return;
    }
    navigate(`${connectedAiPath}?client=${encodeURIComponent(clientId)}`, { replace: true });
  }, [isConnectedAiEnabled, isGetStartedRoute, navigate]);
};
